"use client";

import { c as _c } from "react/compiler-runtime";
import { Text, HStack, VStack, Link, Card, Spinner, Popover, Portal, Switch, SystemStyleObject } from "@chakra-ui/react";
import posthog from "posthog-js";
import Pill from "./pill";
import { RxCross2 } from "react-icons/rx";
import { PillData, LayerIds } from "../data/data";
import { FaCircle, FaSquareFull } from "react-icons/fa";
import { KeyElem } from "./key-elem";
import { Dispatch, SetStateAction, useState } from "react";
import { LayerToggleObjProps } from "./address-mapper";
interface CardHazardProps {
  hazard: {
    id: number;
    name: string;
    title: string;
    description: string;
    info: string[];
    link: {
      label: string;
      url: string;
    };
    icon: string;
    iconColor: SystemStyleObject["color"];
  };
  hazardData?: {
    exists?: boolean;
    last_updated?: string;
  };
  showData: boolean;
  isHazardDataLoading: boolean;
  toggledStates: boolean[];
  setToggledStates: Dispatch<SetStateAction<boolean[]>>;
  setLayerToggleObj: Dispatch<SetStateAction<LayerToggleObjProps>>;
  fullWidth?: boolean;
}
const CardHazard: React.FC<CardHazardProps> = t0 => {
  const $ = _c(75);
  const {
    hazard,
    hazardData,
    showData,
    isHazardDataLoading,
    toggledStates,
    setToggledStates,
    setLayerToggleObj,
    fullWidth: t1
  } = t0;
  const fullWidth = t1 === undefined ? false : t1;
  const {
    id,
    title,
    name,
    description,
    icon,
    iconColor
  } = hazard;
  let t2;
  if ($[0] !== hazardData) {
    t2 = hazardData || {};
    $[0] = hazardData;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    exists
  } = t2;
  let t3;
  if ($[2] !== name) {
    t3 = PillData.find(object => object.name === name) ?? {
      trueData: "No Data",
      falseData: "No Data",
      noData: "No Data"
    };
    $[2] = name;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const pillTextOptions = t3;
  const [isMoreInfo, setIsMoreInfo] = useState(false);
  let t4;
  if ($[4] !== exists || $[5] !== isHazardDataLoading || $[6] !== pillTextOptions || $[7] !== showData) {
    t4 = isHazardDataLoading ? <Spinner size="xs" /> : showData ? <Pill exists={exists} trueData={pillTextOptions.trueData} falseData={pillTextOptions.falseData} noData={pillTextOptions.noData} /> : "";
    $[4] = exists;
    $[5] = isHazardDataLoading;
    $[6] = pillTextOptions;
    $[7] = showData;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const hazardPill = t4;
  let t5;
  if ($[9] !== hazard.info) {
    t5 = () => hazard.info.map(_temp);
    $[9] = hazard.info;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const buildHazardCardInfo = t5;
  let t6;
  if ($[11] !== setLayerToggleObj || $[12] !== setToggledStates || $[13] !== toggledStates) {
    t6 = (num, checked) => {
      const newArray = [...toggledStates];
      newArray[num] = checked;
      setToggledStates(newArray);
      setLayerToggleObj({
        layerId: LayerIds[num],
        toggleState: checked
      });
    };
    $[11] = setLayerToggleObj;
    $[12] = setToggledStates;
    $[13] = toggledStates;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const handleSwitchClick = t6;
  let t7;
  if ($[15] !== fullWidth) {
    t7 = fullWidth ? "none" : {
      base: "xs",
      "2xl": "sm"
    };
    $[15] = fullWidth;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      base: "3.5",
      md: "4"
    };
    t9 = {
      base: "4",
      md: "5"
    };
    $[17] = t8;
    $[18] = t9;
  } else {
    t8 = $[17];
    t9 = $[18];
  }
  const t10 = fullWidth ? "full" : "auto";
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      placement: "bottom",
      flip: false,
      offset: {
        crossAxis: -12,
        mainAxis: 24
      },
      sameWidth: true
    };
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = `${hazard.title} information`;
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = e => setIsMoreInfo(e.open);
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== icon) {
    t14 = icon === "circle" ? <FaCircle /> : <FaSquareFull />;
    $[21] = icon;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== iconColor || $[24] !== t14 || $[25] !== title) {
    t15 = <KeyElem name={title} color={iconColor} icon={t14} />;
    $[23] = iconColor;
    $[24] = t14;
    $[25] = title;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  const t16 = toggledStates[id];
  let t17;
  if ($[27] !== handleSwitchClick || $[28] !== id) {
    t17 = e_0 => handleSwitchClick(id, e_0.checked);
    $[27] = handleSwitchClick;
    $[28] = id;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  let t19;
  let t20;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Switch.HiddenInput />;
    t19 = <Switch.Control />;
    t20 = <Switch.Label />;
    $[30] = t18;
    $[31] = t19;
    $[32] = t20;
  } else {
    t18 = $[30];
    t19 = $[31];
    t20 = $[32];
  }
  let t21;
  if ($[33] !== t16 || $[34] !== t17) {
    t21 = <Switch.Root size="lg" colorPalette="blue" checked={t16} onCheckedChange={t17} defaultChecked={true} gap="0">{t18}{t19}{t20}</Switch.Root>;
    $[33] = t16;
    $[34] = t17;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== t15 || $[37] !== t21) {
    t22 = <Card.Header w="full" p="0" mb="1" textAlign="left" flexDirection="row" justifyContent="space-between">{t15}{t21}</Card.Header>;
    $[36] = t15;
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== description) {
    t23 = <Card.Body textAlign="left" p="0" mb="1.5"><Text textStyle="cardTextMedium" layerStyle="text">{description}</Text></Card.Body>;
    $[39] = description;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== hazard.name || $[42] !== isMoreInfo) {
    t24 = () => {
      if (!isMoreInfo) {
        posthog.capture("more-info-clicked", {
          hazard_name: hazard.name
        });
      }
    };
    $[41] = hazard.name;
    $[42] = isMoreInfo;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  const t25 = !isMoreInfo ? "More info" : "Less info";
  let t26;
  if ($[44] !== t24 || $[45] !== t25) {
    t26 = <Popover.Trigger><Text cursor="button" textDecoration="underline" onClick={t24}>{t25}</Text></Popover.Trigger>;
    $[44] = t24;
    $[45] = t25;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  let t27;
  if ($[47] !== hazardPill || $[48] !== t26) {
    t27 = <Card.Footer p="0" width="full"><HStack justifyContent="space-between" width="full">{t26}{hazardPill}</HStack></Card.Footer>;
    $[47] = hazardPill;
    $[48] = t26;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  let t28;
  if ($[50] !== t22 || $[51] !== t23 || $[52] !== t27) {
    t28 = <VStack alignItems="flex-start" flexGrow={1} h="full">{t22}{t23}{t27}</VStack>;
    $[50] = t22;
    $[51] = t23;
    $[52] = t27;
    $[53] = t28;
  } else {
    t28 = $[53];
  }
  let t29;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <Popover.CloseTrigger cursor="button" position="absolute" top="2" right="2"><RxCross2 color="grey.900" size="20" data-testid="clear-icon" /></Popover.CloseTrigger>;
    $[54] = t29;
  } else {
    t29 = $[54];
  }
  let t30;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <Popover.Arrow><Popover.ArrowTip /></Popover.Arrow>;
    $[55] = t30;
  } else {
    t30 = $[55];
  }
  let t31;
  if ($[56] !== buildHazardCardInfo) {
    t31 = buildHazardCardInfo();
    $[56] = buildHazardCardInfo;
    $[57] = t31;
  } else {
    t31 = $[57];
  }
  let t32;
  if ($[58] !== hazard.link.label) {
    t32 = () => posthog.capture("dataset-link-clicked", {
      link_name: hazard.link.label
    });
    $[58] = hazard.link.label;
    $[59] = t32;
  } else {
    t32 = $[59];
  }
  let t33;
  if ($[60] !== hazard.link.label || $[61] !== hazard.link.url || $[62] !== t32) {
    t33 = <Link display="inline-block" href={hazard.link.url} mt="4" target="_blank" rel="noopener noreferrer" textDecoration="underline" onClick={t32}>{hazard.link.label}</Link>;
    $[60] = hazard.link.label;
    $[61] = hazard.link.url;
    $[62] = t32;
    $[63] = t33;
  } else {
    t33 = $[63];
  }
  let t34;
  if ($[64] !== t31 || $[65] !== t33) {
    t34 = <Portal><Popover.Positioner><Popover.Content maxHeight="unset">{t29}{t30}<Popover.Body>{t31}{t33}</Popover.Body></Popover.Content></Popover.Positioner></Portal>;
    $[64] = t31;
    $[65] = t33;
    $[66] = t34;
  } else {
    t34 = $[66];
  }
  let t35;
  if ($[67] !== t12 || $[68] !== t28 || $[69] !== t34) {
    t35 = <Popover.Root positioning={t11} closeOnEscape={true} closeOnInteractOutside={true} aria-label={t12} onOpenChange={t13}>{t28}{t34}</Popover.Root>;
    $[67] = t12;
    $[68] = t28;
    $[69] = t34;
    $[70] = t35;
  } else {
    t35 = $[70];
  }
  let t36;
  if ($[71] !== t10 || $[72] !== t35 || $[73] !== t7) {
    t36 = <Card.Root flex={1} maxW={t7} py={t8} px={t9} variant="elevated" w={t10}>{t35}</Card.Root>;
    $[71] = t10;
    $[72] = t35;
    $[73] = t7;
    $[74] = t36;
  } else {
    t36 = $[74];
  }
  return t36;
};
export default CardHazard;
function _temp(infoItem, index) {
  return <Text as="p" mt="4" key={index}>{infoItem}</Text>;
}